import NavigationBar from "../navigation/nav-bar/navigationBar";
import FooterComponent from "../navigation/footer/footerComponent";
import ContactUsBodyComponent from "./contactUsBodyComponent";


export default function MainContactUsPage() {

    return (
        <div>
            <NavigationBar />
            <ContactUsBodyComponent />
            <FooterComponent />
        </div>
    )
}